import { useContext, useEffect, useState } from 'react';

import { PageLayout } from '../../components/page-layout';
import {
    BACK_TO_START,
    COPIED,
    LOGIN_TROUBLE_DESCRIPTION_START,
    LOGIN_TROUBLE_DESCRIPTION_END,
    PASSWORD_RESET,
    YOUR_PASSWORD_WAS_RESET_NEXT_LOGIN_DESCRIPTION,
    YOUR_TEMPORARY_PASSWORD_IS,
} from '../../translator/phrase-keys';
import { LanguageContext } from '../../components/language-settings';

export function ResetView({ changeView }) {
    const [temporaryPassword, setTemporaryPassword] = useState("");
    const [showCopyNotice, setShowCopyNotice] = useState(false);
    const {translator} = useContext(LanguageContext);

    useEffect( () => {
        const [loaded, password] = loadLocalStorageData();
        if (!loaded) {
            changeView("verify");
        } else {
            setTemporaryPassword(password);
        }
    }, []);

    function backToStart() {
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("expires");
        sessionStorage.removeItem("temporary_password");
        
        changeView("identity");
    }

    function copyPassword() {
        navigator.clipboard.writeText(temporaryPassword).then(() => {
            setShowCopyNotice(true);
        });
    }

    return (
        <PageLayout
            image="svg/reset.svg"
            progress="3"
            title={translator.translate(PASSWORD_RESET)}
            description={translator.translate(YOUR_PASSWORD_WAS_RESET_NEXT_LOGIN_DESCRIPTION)}
        >
            <div className="page-content-description">
                {translator.translate(YOUR_TEMPORARY_PASSWORD_IS)}
            </div>

            <div className="password-box">
                <span>
                    {temporaryPassword}
                </span>
                <svg
                    className="copy-password-icon"
                    onClick={() => copyPassword()}>
                    <use href="svg/copy.svg#src" />
                </svg>
                <div
                    className={"password-copied-notice" + (showCopyNotice ? " show" : "")}
                    onAnimationEnd={() => setShowCopyNotice(false)}
                >
                    {translator.translate(COPIED)}
                </div>
            </div>

            <div className="page-content-description">
                {<LoginTroubleText
                    start={translator.translate(LOGIN_TROUBLE_DESCRIPTION_START)}
                    end={translator.translate(LOGIN_TROUBLE_DESCRIPTION_END)}
                />}
            </div>

            <span className="page-link" onClick={() => backToStart()}>
                {translator.translate(BACK_TO_START)}
            </span>
        </PageLayout>
    );
}

function LoginTroubleText({start, end}) {
    return <p>
        {start + " "}
        <a href="http://login.microsoftonline.com/" target="_blank" rel="noreferrer">Microsoft</a>
        {" " + end}
    </p>
}

function loadLocalStorageData() {
    const password = sessionStorage.getItem("temporary_password");
    if (!password)
        return [false, ""];

    return [true, password];
}